// extracted by mini-css-extract-plugin
export default {"wrapper":"MBF_k8","reset-button":"TbygAL","item":"j0YERY","dots":"riDqKa","item-active":"hXf1ow"};